import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import { lazy } from 'react';
import Loadable from 'ui-component/Loadable';
// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';

// login routing
const AuthLogin = Loadable(lazy(() => import('views/authentication/Login')));
// const AuthRegister = Loadable(lazy(() => import('views/authentication/Register')));
const AuthVerification = Loadable(lazy(() => import('views/authentication/CodeVerification')));
const AuthForgotPassword = Loadable(lazy(() => import('views/authentication/ForgotPassword')));
const AuthResetPassword = Loadable(lazy(() => import('views/authentication/ResetPassword')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    element: (
        <NavMotion>
            <GuestGuard>
                <MinimalLayout />
            </GuestGuard>
        </NavMotion>
    ),
    children: [
        {
            path: '/login',
            element: <AuthLogin />
        },
        {
            path: '/register',
            element: <AuthLogin />
        },
        {
            path: '/verification',
            element: <AuthVerification />
        },
        {
            path: '/forgot',
            element: <AuthForgotPassword />
        },
        {
            path: '/reset-password',
            element: <AuthResetPassword />
        }
    ]
};

export default LoginRoutes;
